/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RecommendCompany,
    RecommendCompanyFromJSON,
    RecommendCompanyFromJSONTyped,
    RecommendCompanyToJSON,
} from './RecommendCompany';

/**
 * メディアユーザーにおすすめの企業を取得するAPIのレスポンス（新UI用）
 * @export
 * @interface RecommendCompaniesResponse
 */
export interface RecommendCompaniesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof RecommendCompaniesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof RecommendCompaniesResponse
     */
    message: string;
    /**
     * おすすめ企業一覧
     * @type {Array<RecommendCompany>}
     * @memberof RecommendCompaniesResponse
     */
    data: Array<RecommendCompany>;
}

export function RecommendCompaniesResponseFromJSON(json: any): RecommendCompaniesResponse {
    return RecommendCompaniesResponseFromJSONTyped(json, false);
}

export function RecommendCompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendCompaniesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(RecommendCompanyFromJSON)),
    };
}

export function RecommendCompaniesResponseToJSON(value?: RecommendCompaniesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(RecommendCompanyToJSON)),
    };
}

